var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberZero = function SvgIconNumberZero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.405 4.537C7.753 2.589 9.715 1.25 12 1.25s4.247 1.339 5.595 3.287C18.946 6.488 19.75 9.13 19.75 12s-.804 5.512-2.155 7.464C16.247 21.41 14.285 22.75 12 22.75s-4.247-1.339-5.595-3.286C5.054 17.511 4.25 14.87 4.25 12s.804-5.512 2.155-7.463m1.644 1.138C6.957 7.252 6.25 9.485 6.25 12s.707 4.748 1.8 6.325c1.094 1.581 2.507 2.425 3.95 2.425s2.856-.844 3.95-2.425c1.093-1.577 1.8-3.81 1.8-6.325s-.707-4.748-1.8-6.325C14.857 4.094 13.444 3.25 12 3.25s-2.856.844-3.95 2.425",
    clipRule: "evenodd"
  })));
};
export default SvgIconNumberZero;